// extracted by mini-css-extract-plugin
export var technology = "Technology-module--technology--3keMW";
export var libraries = "Technology-module--libraries--1nFBe";
export var languages = "Technology-module--languages--3u4g0";
export var chart = "Technology-module--chart--2U0Fu";
export var chart__item = "Technology-module--chart__item--1LLkt";
export var legend = "Technology-module--legend--1y464";
export var legend__item = "Technology-module--legend__item--3BGED";
export var legend__circle = "Technology-module--legend__circle--AXHUg";
export var legend__label = "Technology-module--legend__label--VUP9E";